import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import AccountServiceModel from '@/models/AccountServiceModel';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';
import Blamable            from '@/models/traits/Blamable';

export enum AccountSubscriptionStatusId {
	enabled = '1',
	disabled = '2',
}

@model.cacheDuration()
@model.urnResource('account_subscription_status')
@doc.path('/account_subscription_statuses/{?id}')
export default class AccountSubscriptionStatusModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'accountSubscriptionStatusHistories': id;
		'accountSubscriptions': id;
		'reference': Account_AccountSubscriptionStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
	};	

	@doc.string declare label: string;
	@doc.string declare reference: Account_AccountSubscriptionStatusReference;

	public get color() {
		switch (this.reference) {
			case 'ENABLED':
				return 'success';
			case 'DISABLED':
				return 'error';
			case 'PAST_DUE':
				return 'warning';
			default:
				return 'default';
		}
	}
}